module.exports = __webpack_public_path__ + "img/8.654b774a.jpg";